import { ListItem, ListItemIcon, ListItemText, Menu } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import NoteIcon from "@material-ui/icons/Note";
import DFMenuItem from "components/DFCustoms/DFMenuItem";
import DFNotePin from "components/DFIcons/DFNotePin";
import useUserContext from "hooks/context-hooks/useUserContext";
import useModal from "hooks/useModal";
import { useEffect, useState } from "react";
import { NoteLog } from "types/common";
import { useUpdatePinnedLog } from "utils/hooks/apiHooks/notes-feature/useUpdatePinnedLog";
import UpsertNoteDialog from "./UpsertNoteDialog";

type NoteItemProps = {
  content: string;
  isPinned: boolean;
  foldColor?: string;
  onEdit?: () => void;
  fullWidth?: boolean;
  hidePin?: boolean;
  backgroundColor?: string;
  logId?: string;
  val?: NoteLog;
  // date: string;
};

export default function NoteItem({
  content,
  isPinned,

  fullWidth,
  hidePin,
  backgroundColor,
  logId,
  val,
}: NoteItemProps) {
  const [open, setOpen] = useState<boolean>();
  const { user } = useUserContext();

  const [anchorEl, closeModal, openModal] = useModal("note_item_dropdown_menu");
  const handleClick = (event: any) => {
    openModal(event.currentTarget);
    event.stopPropagation();
  };
  const [innerIsPinned, setInnerIsPinned] = useState<boolean>();
  useEffect(() => {
    setInnerIsPinned(isPinned);
  }, [isPinned]);

  const [updatePinnedStatus] = useUpdatePinnedLog(() => {
    setInnerIsPinned(!innerIsPinned);
  });

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const onEdit = () => {
    setOpenEditDialog(true);
  };

  return (
    <div>
      <div
        style={{
          background: backgroundColor || "#fdfd96",
          position: "relative",
          // boxShadow: "-9px 9px 11px -4px rgba(0,0,0,0.35)",
          boxShadow: "-5px 5px 6px -1px rgba(0,0,0,0.35)",
          marginBottom: 6,
          ...(!fullWidth ? { width: "fit-content" } : {}),
          fontFamily: "Arial, sans-serif",
        }}
      >
        <ListItem
          onClick={(e) => {
            handleClick(e);
          }}
        >
          <ListItemIcon>
            <NoteIcon />
          </ListItemIcon>
          <div style={{ marginRight: 16 }}>
            <ListItemText primary={content} />
          </div>
        </ListItem>

        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "15px",
            height: "15px",
            transform: "rotate(-90deg) ",

            // boxShadow: "-3px -3px 5px -2px rgba(0,0,0,0.35)",
          }}
        >
          {isPinned && (
            <div
              style={{
                transform:
                  "translateX(-10px) translateY(-20px) rotate(140deg) ",
              }}
            >
              <DFNotePin isPinned={isPinned} />
            </div>
          )}
        </div>
      </div>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(event: any) => {
          closeModal();
          event.stopPropagation();
        }}
      >
        <DFMenuItem
          onClick={(event: any) => {
            closeModal();
            updatePinnedStatus({
              logId: logId,
              callType: "note",
              isPinned: !innerIsPinned,
            });
            event.stopPropagation();
          }}
          icon={<DFNotePin isPinned />}
          text={innerIsPinned ? "Unpin" : "Pin to top"}
        />

        <DFMenuItem
          onClick={() => {
            onEdit();
            closeModal();
          }}
          icon={<EditOutlinedIcon />}
          text={"Edit Note"}
        />
      </Menu>

      <UpsertNoteDialog
        editingId={logId}
        open={openEditDialog}
        initialValue={content}
        close={() => {
          setOpenEditDialog(false);
        }}
      />
    </div>
  );
}
